import Button from "../../components/Form/CustomButton";
import arrowLeft from "../../assets/icons/arrowLeft.svg";
import TagButton from "../../components/Common/TagButton";
import { useNavigate, useParams } from "react-router-dom";
import ExpandableText from "../../components/Form/ExpandableText";
import { useThunk } from "../../hooks/useThunk";
import { getSingleUserJobPost } from "../../store";
import { useCallback, useEffect, useState } from "react";
import TimeCalculator from "../../components/Common/TimeCalculator";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import EnhancedPhotoCarousel from "../../components/Common/EnhancedPhotoCarousel";
import { useSelector } from "react-redux";
import ErrorDisplay from "../../error/ErrorDisplay";
import TaskerFeedSkeleton from "../../components/skeleton/TaskerFeedSkeleton";

function ClientTaskerFeed() {
  const navigate = useNavigate();
  const { jobId } = useParams();

  // THUNK: Get Single User Job Post
  const [
    doGetSingleUserJobPost,
    isGetSingleUserJobPost,
    getSingleUserJobPostError,
  ] = useThunk(getSingleUserJobPost);

  // Redux selectors
  const { posts: userJobPosts } = useSelector((state) => state.jobPost.myPosts);

  // STATE: Job Post
  const [jobPost, setJobPost] = useState(null);

  // FUNCTION: fetch job post if not found in local state
  const fetchData = useCallback(async () => {
    const result = await doGetSingleUserJobPost(jobId);
    if (result?.success) {
      setJobPost(result?.response?.data);
    } else {
      console.log("error", result?.error?.message);
    }
  }, [doGetSingleUserJobPost, jobId]);

  useEffect(() => {
    if (jobId) {
      if (userJobPosts?.length) {
        const existingJobPost = userJobPosts.find(
          (post) => post?._id === jobId
        );
        if (existingJobPost) {
          setJobPost(existingJobPost);
        } else {
          fetchData();
        }
      } else {
        fetchData();
      }
    }
  }, [jobId, userJobPosts, fetchData]);

  const locationText =
    jobPost?.location?.subCities?.length > 0
      ? `${jobPost.location.subCities[0]}, ${jobPost?.location.city}`
      : jobPost?.location?.city;
  const images = jobPost?.images || [];
  const categoryItem = jobPost?.category?.categoryItem || "";
  const skills = jobPost?.category?.skills || [];
  const formattedDate = jobPost?.date ? formatYYYY_MM_DD(jobPost?.date) : "";
  const formattedTime = jobPost?.time ? jobPost?.time : "";
  // ? new Date(`1970-01-01T${jobPost.time}:00`).toLocaleTimeString("en-US", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   })
  // : "";

  return (
    <>
      <div className="w-full px-5 sm:px-[20px] md:px-[40px] lg:px-[100px] mt-12 mb-10">
        <div className="flex justify-end">
          <Button
            buttonText="Back"
            icon={<img src={arrowLeft} alt="Arrow Left" />}
            iconPosition="left"
            className="gap-2 px-[16px]"
            width="0"
            onClick={() => navigate(-1)}
          />
        </div>

        {/* Show loading state when fetching data */}
        {isGetSingleUserJobPost ? (
            <TaskerFeedSkeleton />
        ) : getSingleUserJobPostError ? (
          <ErrorDisplay
            errorMessage={getSingleUserJobPostError?.message || "An error occurred"}
            buttonText="Try Again"
            onButtonClick={() => {
              fetchData();
            }}
          />
        ) : jobPost ? (
          <div className="main-container mt-[12px] p-5 sm:p-[24px] md:p-[48px] flex flex-col space-y-[24px] rounded-t-[20px] border-[1px] border-[#DDE1E6] bg-[#fff]">
            <div className="flex flex-col heading lg:flex-row lg:justify-between">
              <div className="flex flex-col mb-4 lg:mb-0">
                <p className="text-[var(--primary-color)] font-inter text-2xl sm:text-[32px] font-semibold break-words">
                  {jobPost?.title}
                </p>
                <p className="text-content font-inter text-[16px] font-normal">
                  {locationText}
                </p>
              </div>
              <p className="text-[var(--primary-color)] font-inter text-[18px] font-semibold">
                <TimeCalculator date={jobPost.updatedAt} />
              </p>
            </div>

            <div>
              <EnhancedPhotoCarousel
                images={images}
                showNavigation={images.length > 1}
                showThumbnails={images.length > 1}
              />
            </div>

            <div className="decription flex flex-col mt-[36px]">
              <p className="text-content text-[16px] sm:text-[18px] font-inter font-semibold">
                {jobPost.description ? "Description" : ""}
              </p>
              <div>
                <ExpandableText text={jobPost?.description} />
              </div>

              <div className="mt-[24px] flex flex-col sm:flex-row sm:gap-[87px] space-y-4 sm:space-y-0">
                <div className="space-y-[12px] ">
                  <p className="text-content text-[18px] font-semibold font-inter">
                    Date
                  </p>
                  <p className="text-content text-[16px] font-normal font-inter">
                    {formattedDate}
                  </p>
                </div>
                <div className="space-y-[12px] ">
                  <p className="text-content text-[18px] font-semibold font-inter">
                    Time
                  </p>
                  <p className="text-content text-[16px] font-normal font-inter">
                    {formattedTime}
                  </p>
                </div>
              </div>

              <div className="mt-[24px] flex flex-col sm:flex-row sm:gap-[52px] space-y-4 sm:space-y-0">
                <div className="space-y-[12px]">
                  <p className="text-content text-[18px] font-semibold font-inter">
                    Category
                  </p>
                  <TagButton title={categoryItem} />
                </div>
                <div className="space-y-[12px] ">
                  <p className="text-content text-[18px] font-semibold font-inter">
                    Skill
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {skills.map((skill, index) => (
                      <TagButton key={index} title={skill} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default ClientTaskerFeed;
